<section class="container bgWhite">
  <section class="col-md-12 col-sm-12 col-xs-12">
    <div class="manage-week">
      <form [formGroup]="fileUploadForm">
        <h4>STS shipping commitments</h4>
        <p>Upload commitment data</p>
        <div class="browse-btn-group">
          <div class="wrapper">
            <input readonly type="text" formControlName="excelUploadFile">
            <input id="sts-input-file" name="excelFile" type="file" class="hide" (change)="onFileSelect($event)"
              (click)="$event.target.value=null" #fileUpload>
            <button type="button" class="btn btn-primary browse-btn stsblue-button" id="browse-btn"
            data-di-id="#browse-btn" (click)="refreshValue(); fileUpload.click();uploadRes = ''">Browse</button>
          </div>
          @if (uploadRes?.status === 'File type is incorrect') {
            <span class="error">The uploaded file should be xls
            format.</span>
          }
        </div>
        <button type="button" class="btn btn-primary browse-btn stsblue-button upload" (click)="openModal(content)"
        [disabled]="fileUploadForm.invalid || !fileUploadForm.get('excelUploadFile').value">Upload</button>
        <button type="button" class="btn btn-primary stsblue-button export" (click)="downloadExcel()">Export to
        Excel</button>
        <div class="upld-date">Last upload date: @if (shippingData.length > 0) {
          <span>{{shippingData[0]?.lastUpdated |
            date: 'MMM d, yyyy, h:mm:ss
          a'}}</span>
        }
        &nbsp;&nbsp;&nbsp;
      </div>
      <ng-template #content let-modal>
        <div class="popup-comp">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title-top20"> VaccineShop</h4>
            </div>
            <div class="modal-body">
              <p class="itemlist"> This will override the current data. Do you want to proceed? </p>
            </div>
            <div class="modal-footer">
              <div class="change-request-btngrps">
                <button type="submit" class="btn btn-primary" (click)="uploadFileDetails()"
                [disabled]="disable">Yes</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                (click)="hideModal()">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </form>
  </div>
  @if (!isLoadingDone) {
    <app-loader [data]="''"></app-loader>
  }
  <div class="top-pagination">
    <!-- <div class="col-md-7 col-sm-6 hidden-xs filterApply-showing"> -->

  <!-- </span> -->
  <div class="pagination">
    <div class="showing">Showing {{ end }} of {{ totalOrders }} orders</div>
    <button [disabled]="currentPage == 1" (click)="getCurrentPage('prev')" class="pagination-btns mr-1">
      <span class="chevronIconWhite prev"></span>
    </button>

        <button class="pagination-btns" [disabled]="
      currentPage >= totalOrders / pageSize ||
(totalOrders === 0 && pageSize === 0)" (click)="getCurrentPage('next')">
      <span class="chevronIconWhite next"></span>
    </button>
  </div>
</div>

<div class="col-md-12 sts-cust-upld">
  <table id="backoffice-table" class="backoffice-table display" style="width:100%">
    <thead>
      <tr class="heading">
        <th class="cust-no">Start Date</th>
        <th class="tier-no">End Date</th>
        <th class="order no-sort">Percentage</th>
        <th class="cust-no">Material Number</th>
        <th class="tier-no">Contract Number</th>
        <th class="order no-sort">Update</th>
        <th class="order no-sort">Delete</th>
      </tr>
    </thead>
    @if (shippingData && shippingData?.length !== 0) {
      <tbody class="datatable-row">
        @for (data of shippingData; track data; let i = $index) {
          <tr class="week-table-row">
            <td class="text-center">
              <div class="Fields-container ">
                <input type="text" name="startDate" placeholder="" class="Fields-input field-optional start-date"
                  bsDatepicker [maxDate]="maxSelectionDate" [daysDisabled]="[0, 6]" [(ngModel)]="data.startDt"
                  [bsConfig]="{ containerClass: 'order-list-date',dateInputFormat: 'MM/DD/YYYY' }"
                  (focus)="focusValidation(data,0)" onkeydown="return false">
                @if ((data.startDt === '' || data.startDt === undefined || dateCheck(data)) &&
                  data?.notFocused[0] && data.active) {
                  <span class="error-text">
                    Shipment start date must be before end date
                  </span>
                }
                @if (startDateValidation(data) && data?.notFocused[0] && data.active) {
                  <span class="error-text">
                  Please select applicable week's first day </span>
                }
              </div>
            </td>
            <td class="text-center">
              <div class="Fields-container ">
                <input type="text" name="endDate" placeholder="" class="Fields-input field-optional end-date"
                  bsDatepicker [maxDate]="maxSelectionDate" [daysDisabled]="[0, 6]" [(ngModel)]="data.endDt"
                  [bsConfig]="{ containerClass: 'order-list-date',dateInputFormat: 'MM/DD/YYYY' }"
                  (focus)="focusValidation(data,1)" onkeydown="return false">
                <!-- <span class="error-text" *ngIf="dateValidation(data) && data?.notFocused[1] && data.endError[0]">
              Shipment start date must be before end date</span> -->
              @if ((data.endDt === '' || data.endDt === undefined || dateCheck(data)) &&
                data?.notFocused[1] && data.active) {
                <span class="error-text">
                Shipment start date must be before end date</span>
              }
              @if (endDateValidation(data) && data?.notFocused[1] && data.active) {
                <span class="error-text">
                Please select applicable week's first day</span>
              }
            </div>
          </td>
          <td class="text-center">
            <div class="Fields-container ">
              <input name="tier" type="text" placeholder="" [(ngModel)]="data.percentage"
                class="Fields-input field-optional tiers text-center" autocomplete="off"
                (focus)="focusValidation(data,2)">
              @if ((data.percentage === '' || data.percentage === null) && data?.notFocused[2] && data.active) {
                <span class="error-text"
                  >This
                  field is
                required</span>
              }
              @if (allowNumber(data.percentage) && data?.notFocused[2] && data.active) {
                <span class="error-text">
                Percentage value should be less than or equal to 100</span>
              }
            </div>
          </td>
          <td class="text-center">
            <div class="Fields-container ">
              <input name="tier" type="text" maxlength="6" placeholder=""
                class="Fields-input field-optional tiers text-center" [(ngModel)]="data.materialNumber"
                autocomplete="off" (focus)="focusValidation(data,3)">
              @if ((data.materialNumber === '' || data.materialNumber === null) && data?.notFocused[3] && data.active) {
                <span class="error-text"
                  >
                This field is required</span>
              }
              @if (materialRegex(data.materialNumber) && data?.notFocused[3] && data.active) {
                <span class="error-text"
                  >
                Please enter valid material number</span>
              }
            </div>
          </td>
          <td class="text-center">
            <div class="Fields-container ">
              <input name="tier" type="number" placeholder="" class="Fields-input field-optional tiers text-center"
                [(ngModel)]="data.contractNumber" autocomplete="off">
            </div>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-primary stsblue-button1 update-row"
            (click)="update(data, i)">Update</button>
          </td>
          <td class="text-center">
            <div class="Fields-container ">
              <button type="button" class="btn btn-primary stsblue-button1 delete-row" data-toggle="popover"
                data-placement="top" data-target="save-cart-0" data-original-title="" id="linkViewDelete"
                aria-labelledby="cartHeading" data-di-id="#linkViewDelete" [ngbPopover]="popDeltContent"
                [popoverTitle]="popDeltTitle" triggers="manual" (click)="toggle(p3)" #p3="ngbPopover" placement="top"
              container="body" popoverClass="popover-links commitment-popover {{baseSiteId}}">Delete</button>
              <ng-template #popDeltTitle><span class="text-header">
                Are you sure you want to delete this tier?
              </span></ng-template>
              <ng-template #popDeltContent>
                <button type="reset" class="btn-secondary" data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p3)">
                  Cancel
                </button>
                <button class="btn-primary" type="submit" data-di-id="di-id-3064f17d-e97cc628"
                  (click)="delete(data, i)">
                  Delete
                </button>
              </ng-template>
            </div>
          </td>
        </tr>
      }
    </tbody>
  }
</table>
</div>
</section>
</section>